<script setup>
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useConversationTranslation } from 'dashboard/composables/useConversationTranslation';

const store = useStore();

const conversationId = computed(() => store.getters.getSelectedChat?.id);
const messages = computed(() => store.getters.getSelectedChat?.messages || []);

const conversationIdRef = computed(() => conversationId.value);

const { shouldAutoTranslateIncoming, incomingTargetLanguage } =
  useConversationTranslation(conversationIdRef);

const translatedMessageIds = ref(new Set());

const resetTranslatedIds = () => {
  translatedMessageIds.value = new Set();
};

const translateIncomingMessages = () => {
  if (!shouldAutoTranslateIncoming.value || !conversationId.value) return;

  messages.value.forEach(message => {
    if (message.message_type !== 0) return;
    if (translatedMessageIds.value.has(message.id)) return;

    const existingTranslation =
      message.content_attributes?.translations?.[incomingTargetLanguage.value];
    if (existingTranslation) {
      translatedMessageIds.value.add(message.id);
      return;
    }

    translatedMessageIds.value.add(message.id);
    store.dispatch('translateMessage', {
      conversationId: conversationId.value,
      messageId: message.id,
      targetLanguage: incomingTargetLanguage.value,
    });
  });
};

watch(conversationId, resetTranslatedIds);

watch(messages, translateIncomingMessages, { deep: true });

watch(shouldAutoTranslateIncoming, enabled => {
  if (enabled) {
    resetTranslatedIds();
    translateIncomingMessages();
  }
});

watch(incomingTargetLanguage, () => {
  resetTranslatedIds();
  translateIncomingMessages();
});
</script>

<template>
  <span class="hidden" />
</template>
